import { useEffect, useState } from 'react';
import { brandColor, getEditorColor } from '../../util/ColorUtil';
import {
  getEditorColors,
  isItUndefined,
  modifyLinks,
} from '../../util/DataUtil';
import CtaBarButton from '../base/cta-bar-button';
import FacilityModal from '../modal/FacilityModal';
import { cleanHTML } from '../utils/htmlUtils';
import {useRouter} from "next/router";

const HorizontalNumericalStepper = ({ data, lang, global }) => {
  const [marketoTrigger, setMarketoTrigger] = useState(false);
  const [titleHeight, setTitleHeight] = useState([]);
  const [subtitleHeight, setSubtitleHeight] = useState([]);
  const emphasizedTextColor = getEditorColors(
    isItUndefined(data?.field_horizontal_numerical_title),
    isItUndefined(data?.field_horizontal_numerical_subti)
  ).filter((x) => x)[0];
  const { locale } = useRouter();

  const getItemTitleHeight = () => {
    let height = 0;

    if (typeof window === 'undefined') {
      return;
    }

    let items = document.querySelectorAll('.item .title p');

    if (!items.length) {
      items = document.querySelectorAll('.item .title h4');
    }

    if (!items.length) {
      items = document.querySelectorAll('.item .title h5');
    }

    if (!items.length) {
      items = document.querySelectorAll('.item .title h3');
    }

    if (!items.length) {
      items = document.querySelectorAll('.item .title h2');
    }

    if (!items.length) {
      items = document.querySelectorAll('.item .title h1');
    }

    for (let item of items) {
      if (height < item.clientHeight) {
        height = item.clientHeight;
      }
    }

    setTitleHeight(height);
  };

  const getItemSubtitleHeight = () => {
    let height = 0;

    if (typeof window === 'undefined') {
      return;
    }

    let items = document.querySelectorAll('.item .subtitle p');

    for (let item of items) {
      if (height < item.clientHeight) {
        height = item.clientHeight;
      }
    }

    setSubtitleHeight(height);
  };

  useEffect(() => {
    getItemTitleHeight();
    getItemSubtitleHeight();
  });

  const renderItems = (data, items) => {
    if (!items) {
      return '';
    }

    return items.map((item, index) => {
      return (
        <div key={`item-${item?.field_title_text_title?.[0]?.value || index}`} className={'item count-' + items.length}>
          <span
            style={{ height: titleHeight + 'px', display: 'block' }}
            dangerouslySetInnerHTML={{
              __html: item?.field_title_text_title[0]?.value,
            }}
            className={`title ${emphasizedTextColor ? emphasizedTextColor : ''}`}
          />
          <hr />
          <span
            style={{ height: subtitleHeight + 'px', display: 'block' }}
            dangerouslySetInnerHTML={{
              __html: item?.field_title_text_text[0]?.value,
            }}
            className={`subtitle ${emphasizedTextColor ? emphasizedTextColor : ''}`}
          />
          <hr />
          <span
            className={'index'}
            style={{
              color: brandColor(
                data?.field_horizontal_numerical_num_c[0]?.value
              ),
            }}
          >
            {index + 1}
          </span>
        </div>
      );
    });
  };

  return (
    <>
      <div
        className={'horizontal-numerical'}
        style={{
          backgroundColor: brandColor(
            data?.field_horizontal_numerical_backg[0]?.value
          ),
        }}
      >
        <div className={'inner-container'}>
          {data?.field_horizontal_numerical_title[0]?.value && (
            <h2
              className={`${emphasizedTextColor ? emphasizedTextColor : ''}`}
              dangerouslySetInnerHTML={{
                __html: cleanHTML(
                  modifyLinks(data?.field_horizontal_numerical_title[0]?.value, locale)
                ),
              }}
            />
          )}
          {data?.field_horizontal_numerical_subti[0]?.value && (
            <span
              className={`subtitle ${emphasizedTextColor ? emphasizedTextColor : ''}`}
              dangerouslySetInnerHTML={{
                __html: cleanHTML(
                  modifyLinks(data?.field_horizontal_numerical_subti[0]?.value, locale)
                ),
              }}
            />
          )}
          {data?.field_cta_bar_button_selection.length > 0 ? (
            <CtaBarButton
              blockTypeClass={'horizontal-numerical-stepper'}
              setMarketoTrigger={setMarketoTrigger}
              data={data?.field_cta_bar_button_selection[0]?.cta_bar_button}
              bgColor={getEditorColor(
                brandColor(data?.field_horizontal_numerical_backg[0]?.value)
              )}
              pathname={true}
            ></CtaBarButton>
          ) : (
            <></>
          )}
          <div className={'items'}>
            {renderItems(
              data,
              data?.field_horizontal_numerical_stepp
                ?.title_text_color_paragraph_type
            )}
          </div>
        </div>
      </div>
      {marketoTrigger && (
        <FacilityModal
          lang={lang}
          global={global}
          setTrigger={setMarketoTrigger}
          trigger={marketoTrigger}
        >
          {
            data?.field_cta_bar_button_selection[0]?.cta_bar_button
              ?.field_marketo_blocks[0]?.marketo_form_facility_block_type
          }
        </FacilityModal>
      )}
    </>
  );
};

export default HorizontalNumericalStepper;
